import type {SortDirection} from 'src/openapi/admin/models/SortDirection';

export type ColumnOrder = Record<string, number>;

export type ColumnAdapter = {
    toDisplay: (columns: ColumnOrder) => ColumnOrder,
    toStored: (columns: ColumnOrder, previousColumns: ColumnOrder) => ColumnOrder,
    getSorting: (column: string, direction: SortDirection) => {column: string, direction: SortDirection},
};

export const defaultColumnAdapter: ColumnAdapter = {
    toDisplay: columns => columns,
    toStored: columns => columns,
    getSorting: (column, direction) => ({column, direction}),
};
